export const routes = {
    Login:'/login',
    Register:'/register',
    ResetPassword:'/reset-password',
    Portal:'/patients',
    Dashboard: '/patients/Dashboard',
    Schedule: '/patients/schedule',
    Message: '/patients/message',
    Programs: '/patients/rograms',
    Therapist: '/patients/therapist',
    MyStory: '/patients/my-story',
    Settings: '/patients/Settings',
    LogOut: '/patients/log-out',
}